module.exports = __webpack_public_path__ + "img/CX.4bc5248b.png";